import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import UserService from "../../../services/UserService";
import { getUserByToken } from "./authCrud";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  SetUser: "[Set User] Action",
  SetSeletedCompany: "[Set Selected Comapny] Action",
};

const initialAuthState = {
  user: undefined,
  authToken: undefined,
  selectedCompanyId: undefined,
};

export const reducer = persistReducer(
  { storage, key: "v726-demo1-auth", whitelist: ["authToken", "selectedCompanyId"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Logout: {
        return { ...initialAuthState, user: undefined };
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;

        const selectedCompanyId = state.selectedCompanyId ?? UserService.getFirstAvailableCompanyId(user);

        return { ...state, selectedCompanyId, user };
      }

      case actionTypes.SetUser: {
        const { user } = action.payload;

        const selectedCompanyId = state.selectedCompanyId ?? user?.companyId;

        return { ...state, selectedCompanyId, user };
      }

      case actionTypes.SetSeletedCompany: {
        const { selectedCompanyId } = action.payload;

        return { ...state, selectedCompanyId }
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (authToken) => ({ type: actionTypes.Login, payload: { authToken } }),
  register: (authToken) => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),
  setSelectedCompanyId: (selectedCompanyId) => ({ type: actionTypes.SetSeletedCompany, payload: { selectedCompanyId } }),
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    const { data: user } = yield getUserByToken();

    yield put(actions.fulfillUser(user));
  });
}
